// Indirection over window.location.reload — jsdom's location is frozen, so
// callers that need unit tests mock this module instead.
export const reloadPage = () => window.location.reload();
